import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
  selector: 'pptl-delivery-modal-offline',
  templateUrl: 'modal-offline.component.html',
  styleUrls: ['modal-offline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ModalOfflineComponent {
  @Input()
  modalTitle: string;
  modalText: string;
  modalOkButton: string;

  constructor(public modalController: ModalController) {}

  onCancelButtonClick() {
    this.modalController.dismiss({ status: 'cancel' });
  }

  onOkButtonClick(): void {
    this.modalController.dismiss({ status: 'ok' });
  }
}
